export default __webpack_public_path__ + "static/media/cmnd_bg.fc1d9306.jpg";